<template>
  <div class="relative slide">
    <div
      class="carousel-indicators absolute bottom-0 flex bg-white h-24 w-full justify-center items-center"
    >
      <ol class="z-50 flex w-4/12 justify-center">
        <!-- <li
          v-for="(img, i) in images"
          :key="i"
          class="md:w-4 md:h-4 bg-red-600 rounded-full cursor-pointer mx-2"
        ></li> -->
      </ol>
    </div>

    <div class="carousel-inner relative overflow-hidden w-full">
      <div
        :class="`${active === 0 ? 'active' : 'left-full'}`"
        class="carousel-item inset-0 relative w-full transform transition-all duration-500 ease-in-out"
      >
        <img
          class="block w-full max-h-44 object-contain"
          src="../../assets/slider/ford.svg"
        />
      </div>
      <div
        :class="`${active === 1 ? 'active' : 'left-full'}`"
        class="carousel-item inset-0 relative w-full transform transition-all duration-500 ease-in-out"
      >
        <img
          class="block w-full max-h-44 object-contain"
          src="../../assets/slider/hm.svg"
        />
      </div>
      <div
        :class="`${active === 2 ? 'active' : 'left-full'}`"
        class="carousel-item inset-0 relative w-full transform transition-all duration-500 ease-in-out"
      >
        <img
          class="block w-full max-h-44 object-contain"
          src="../../assets/slider/arabdev.png"
        />
      </div>
      <div
        :class="`${active === 3 ? 'active' : 'left-full'}`"
        class="carousel-item inset-0 relative w-full transform transition-all duration-500 ease-in-out"
      >
        <img
          class="block w-full max-h-44 object-contain"
          src="../../assets/slider/american.svg"
        />
      </div>
      <div
        :class="`${active === 4 ? 'active' : 'left-full'}`"
        class="carousel-item inset-0 relative w-full transform transition-all duration-500 ease-in-out"
      >
        <img
          class="block w-full max-h-44 object-contain"
          src="../../assets/slider/egbank.svg"
        />
      </div>
      <div
        :class="`${active === 5 ? 'active' : 'left-full'}`"
        class="carousel-item inset-0 relative w-full transform transition-all duration-500 ease-in-out"
      >
        <img
          class="block w-full max-h-44 object-contain"
          src="../../assets/slider/noon.svg"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      images: [
        "../../assets/slider/ford.svg",
        "../../assets/slider/hm.svg",
        "../../assets/slider/arabdev.png",
        "../../assets/slider/american.svg",
        "../../assets/slider/egbank.svg",
        "../../assets/slider/noon.svg",
      ],
      active: 0,
    };
  },
  // data: () => ({
  //     images: [
  //         "../../assets/ford.svg",
  //         "../../assets/hm.svg",
  //         "../../assets/arabdev.png",
  //         "../../assets/american.svg",
  //         "../../assets/egbank.svg",
  //         "../../assets/noon.svg",
  //     ],
  //     active: 0,
  // }),
  mounted() {
    let i = 0;
    setInterval(() => {
      if (i > this.images.length - 1) {
        i = 0;
      }
      this.active = i;
      i++;
    }, 3000);
  },
  methods: {
    async getImages() {
      try {
        let apiImg = "https://publish.dkilo.com/api/allLogos";
        const res = await axios.get(apiImg);
        this.images = res.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.left-full {
  left: -100%;
}

.carousel-item {
  float: left;
  position: relative;
  display: block;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
}

.carousel-item.active {
  left: 0;
}
</style>
